/**
 * Created by cuppi on 2017/10/16.
 */
import GlobalConstant from '../util/GlobalConstant';
// import NativeBridge from '../util/NativeBridge';
// import ConvertTool from '../tool/ConvertTool.js'
import DateTool from '../tool/DateTool.js';
import NumberTool from '../tool/NumberTool.js';
// import UnitTool from '../tool/UnitTool.js';
// import ArrayTool from '../tool/ArrayTool.js';
// import StringTool from '../tool/StringTool.js';
import UrlTool from '../tool/UrlTool.js';
import TypeTool from '../tool/TypeTool.js';
// import DimensionalTool from '../tool/DimensionalTool.js';
// import RandomTool from '../tool/RandomTool.js';
import {JToolDate} from 'jbzwebsdk';

class PrototypeConfig {
  static createPrototype(vue) {
    vue.prototype.GlobalConstant = GlobalConstant;
    // vue.prototype.NativeBridge = NativeBridge;
    // vue.prototype.ConvertTool = ConvertTool;
    vue.prototype.DateTool = DateTool;
    vue.prototype.NumberTool = NumberTool;
    // vue.prototype.UnitTool = UnitTool;
    // vue.prototype.ArrayTool = ArrayTool;
    // vue.prototype.StringTool = StringTool;
    vue.prototype.UrlTool = UrlTool;
    vue.prototype.TypeTool = TypeTool;
    // vue.prototype.RandomTool = RandomTool;
    // vue.prototype.DimensionalTool = DimensionalTool;
    vue.prototype.JToolDate = JToolDate;
    // 判断手机型号
    let ua = navigator.userAgent.toLowerCase();
    if (!/iphone|ipad|ipod|itouch/.test(ua)) {
      vue.prototype.ScreenSize = {
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight
      };
      vue.prototype.OSType = 'android';
    } else {
      vue.prototype.ScreenSize = {
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight
      };
      vue.prototype.OSType = 'ios';
    }

    vue.prototype.showLoading = function () {
      if (!this.loadingCounter){
        this.loadingCounter = 0;
      }
      this.loadingCounter++;
      GlobalConstant.store.commit('SHOW_LOADING_MUTATION', true)
    };

    vue.prototype.closeLoading = function () {
      if (this.loadingCounter < 1){
        console.log('closeLoading 最先调用');
        return;
      }
      if (--this.loadingCounter < 1){
        GlobalConstant.store.commit('SHOW_LOADING_MUTATION', false)
      }
    };
    // 彭大帅暂时增加使用于无网络情况
    vue.prototype.closeSignalAlert = function () {
      GlobalConstant.store.commit('signalAlert', {show: false})
    };
    vue.prototype.title = function (title) {
      document.title = title
      // 解决ios兼容问题
      let iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      // iframe.setAttribute('src', './favicon.ico');
      let breakIt = function () {
        setTimeout(function () {
          iframe.removeEventListener('load', breakIt)
          document.body.removeChild(iframe)
        }, 0)
      };
      iframe.addEventListener('load', breakIt)
      document.body.appendChild(iframe)
    };
    Array.prototype.remove = function (el) {
      var index = this.indexOf(el);
      if (index === -1) {
        return null;
      }
      return this.splice(index, 1)[0];
    };
    // 彭大帅，删除左右两边空格方法
    String.prototype.trim = function(){
      return this.replace(/(^\s*)|(\s*$)/g, '');
    };
    String.prototype.ltrim = function(){
      return this.replace(/(^\s*)/g, '');
    };
    String.prototype.rtrim = function(){
      return this.replace(/(\s*$)/g, '');
    };
  }
}

export default PrototypeConfig;
